import { render, staticRenderFns } from "./my-certificate.vue?vue&type=template&id=586739b3&scoped=true"
import script from "./my-certificate.vue?vue&type=script&lang=js"
export * from "./my-certificate.vue?vue&type=script&lang=js"
import style0 from "./my-certificate.vue?vue&type=style&index=0&id=586739b3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586739b3",
  null
  
)

export default component.exports